import VillaListSection from './VillaListSection';

export default VillaListSection;
